import { useTranslation } from 'react-i18next';

const rooms = [
  {
    titleKey: 'room_bedroom1',
    bedsKey: 'bed_double',
    icon: 'ri-hotel-bed-line',
    image: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/e2ff0e78-5a4c-47bb-a4ad-c52c5cb077e1_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.20.webp',
  },
  {
    titleKey: 'room_bedroom2',
    bedsKey: 'bed_bunk',
    icon: 'ri-hotel-bed-line',
    image: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/8ba665fc-ae25-48e3-9deb-70a1263e913d_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.50.webp',
  },
  {
    titleKey: 'room_bathroom',
    bedsKey: 'bath_1full',
    icon: 'ri-drop-line',
    image: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/68379352-338b-45ac-8ad4-be263e9020af_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.34.webp',
  },
];

export default function GolfoLayout() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('layout_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">{t('layout_title')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {rooms.map((room) => (
            <div key={room.titleKey} className="bg-background-100 rounded-lg overflow-hidden group cursor-default">
              <div className="aspect-[6/5] overflow-hidden">
                <img
                  src={room.image}
                  alt={`${t(room.titleKey)} at Casa de El Golfo - ${t(room.bedsKey)}`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className={`${room.icon} text-base`}></i>
                  </span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{t(room.titleKey)}</h3>
                </div>
                <p className="text-sm text-foreground-600">{t(room.bedsKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}